import { useAppDispatch } from '../useAppDispatch';
import { ELandingType } from '../../types/landingType';
import { EActivateInsuranceStep } from '../../types/activateInsurance/step';
import { setStepsConfiguration as setInsuranceStepsConfiguration } from '../../slices/activateInsurance';
import { setStepsConfiguration as setJoinOtaLegalShortConfiguration } from '../../slices/joinOtaLegalShort';
import { setStepsConfiguration as setIndividualStepsConfiguration } from '../../slices/joinOtaIndividual';
import { setStepsConfiguration as setBusinessEntityStepsConfiguration } from '../../slices/businessEntityFlow';
import { EJoinOtaLegalShortStep } from '../../types/joinOtaLegalShort/step';
import { EJoinOtaStep } from '../../types/joinOtaIndividual/step';
import { setLandingType } from '../../slices/landingType';
import { getSteps } from '../../utils/getSteps';
import { TStep } from '../../types/step';
import { EBusinessEntityStep } from '../../types/businessEntityFlow/step';

export const useLandingsRouting = () => {
  const dispatch = useAppDispatch();

  const routeToStep = (landingType: ELandingType, step: TStep) => {
    let steps;
    switch (landingType) {
      case ELandingType.ActivateInsurance:
        steps = getSteps(ELandingType.ActivateInsurance) as EActivateInsuranceStep[];
        dispatch(setInsuranceStepsConfiguration({ steps, activeStep: step as EActivateInsuranceStep }));
        break;
      case ELandingType.JoinOtaLegalShort:
        steps = getSteps(ELandingType.JoinOtaLegalShort) as EJoinOtaLegalShortStep[];
        dispatch(setJoinOtaLegalShortConfiguration({ steps, activeStep: step as EJoinOtaLegalShortStep }));
        break;
      case ELandingType.JoinOtaCian:
        steps = getSteps(ELandingType.JoinOtaCian) as EJoinOtaStep[];
        dispatch(setIndividualStepsConfiguration({ steps, activeStep: step as EJoinOtaStep }));
        break;
      case ELandingType.BusinessEntityFlow:
        steps = getSteps(ELandingType.BusinessEntityFlow) as EBusinessEntityStep[];
        dispatch(setBusinessEntityStepsConfiguration({ steps, activeStep: step as EBusinessEntityStep }));
        break;
      default:
        steps = [];
    }

    dispatch(setLandingType({ landingType }));
  };

  return { routeToStep };
};
